import { Card, Group, Stack } from '@mantine/core';
import type { CeleryWorker } from '@repo/api-codegen';
import { Icon, Text } from '@repo/foundations';
import { useStyles } from '../InspectCeleryPage.styles';

interface WorkerCardProps {
	worker: CeleryWorker;
	onClick: () => void;
}

export function WorkerCard({ worker, onClick }: WorkerCardProps) {
	const { classes, theme } = useStyles();

	return (
		<Card
			className={`${classes.card} ${classes.hoverCard}`}
			bg={theme.other.getColor('surface/primary/default')}
			style={{ cursor: 'pointer' }}
			onClick={onClick}
		>
			<Stack spacing="sm">
				<Group spacing="xs">
					<Icon name="serverBolt" color="icon/primary/default" size="md" />
					<Text size="sm" weight="semibold" color="text/primary/default">
						{worker.name}
					</Text>
				</Group>

				<Stack spacing="xs">
					<Group spacing="xs">
						<Text size="xs" color="text/secondary/default">
							Uptime: {Math.floor(worker.uptime / 60)} min
						</Text>
					</Group>
					<Group spacing="xs">
						<Text size="xs" color="text/secondary/default">
							Peak memory usage:
							{worker.rusage?.maxrss !== undefined
								? ` ${worker.rusage.maxrss} KB`
								: ' N/A'}
						</Text>
					</Group>
				</Stack>
			</Stack>
		</Card>
	);
}
